import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { initTheme } from '@atreus/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/global.css';

import { AuthGate } from './components/AuthGate.js';
import { initSentry, SentryErrorBoundary } from './lib/sentry.js';
import { router } from './routes.js';

initTheme();
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('No #root element found');

createRoot(rootElement).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={
        <div className="p-8 text-danger">
          Algo salió mal. Recarga la página para continuar.
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <AuthGate>
          <RouterProvider router={router} />
        </AuthGate>
      </QueryClientProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
